import { render, staticRenderFns } from "./WholesaleBillImages.vue?vue&type=template&id=4f23e60c&"
import script from "./WholesaleBillImages.vue?vue&type=script&lang=ts&"
export * from "./WholesaleBillImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports